import {
  setTrk,
  TrkTag,
  TrkPageType,
} from '@nerdwallet/nw-client-lib/trk-helper';

import { getTaxonomyObject } from './page-taxonomy';

export function parseTrkParams({ element, location, copy }) {
  return {
    [TrkTag.pageType]: TrkPageType.calculator,
    [TrkTag.element]: element, // Could lookup TrkElement from trk-helper, but this will probably be more error prone
    [TrkTag.location]: location,
    [TrkTag.copy]: copy,
  };
}

/**
 * Helper for generating URLs with proper, validated TRK codes.  Automatically sets:
 * - trk_vertical (from taxonomy.vertical)
 * - trk_topic (from taxonomy.topic)
 * - trk_nldt (from taxonomy.pageType)
 * - trk_channel (always set to web)
 *
 * @param {String} calc Which calc the link is from; 'rc', 'mc' or 'hac'
 * @param {String} url Base URL (without any TRK codes). May contain query string.
 * @param {Object} params key should be unresolved TRK code; `element`, `location`, `copy`
 * @returns {String} `url` with attached trk codes
 */
export default function internalLink(calc, url, params) {
  return setTrk({
    params: parseTrkParams(params),
    taxonomy: getTaxonomyObject(calc),
    url,
  });
}
